module.exports = __webpack_public_path__ + "img/1-(6).6f28f55f.jpg";